import { object, string, mixed } from 'yup';

export const create = object({
  subject: string().min(2).required().label('عنوان'),
  description: string().required().label('توضیحات'),
  type: mixed().required().label('نوع بازخورد')
});
